module.exports = __webpack_public_path__ + "static/media/comercioExterior.291d5826.svg";